<section class="app2 about format" id="about">
  <div class="animated-bg"><i></i><i></i><i></i></div>
  <div class="container">
    <div class="row">
      @defer(when headText){
      <div class="col-sm-4 counters set-height d-flex justify-content-center me-5 mb-5">
        <picture>
          <source media="(min-width: 600px)" [srcset]="aboutImage?.data?.attributes?.formats?.medium?.url">
          <source media="(max-width: 599px)" [srcset]="aboutImage?.data?.attributes?.formats?.small?.url">
          <img [src]="aboutImage?.data?.attributes?.formats?.thumbnail?.url" loading="lazy" fetchpriority="high"
            [alt]="aboutImage?.data?.attributes?.alternativeText" class="img-fluid mobile1">
        </picture>
      </div>
      <div class="col-sm-6 counters">
        <div class="abouts center-text">
          <div class="about-box ">
            <div class="format-head-text">
              <p class="about-font-header title-text">{{headText}}</p>
            </div>
            <div class="format-sub-text">
              <p class="about-para mb-2">{{subText}}</p>
            </div>
            @for (item of aboutList; track $index) {
            <div class="list-about">
              <p class="mb-2">
                {{item.functionLi}}
              </p>
            </div>
            }
            <a></a>
          </div>
        </div>
      </div>
      }@placeholder {
      @switch (screenSize$ | async) {
      @case ('xsmall') {
      <!-- Conteúdo para telas muito pequenas -->
      <div class="col-sm-4 counters set-height d-flex justify-content-center me-5">
        <ngx-skeleton-loader [theme]="{height:'26.125em', width:'18.8875em'}" />
      </div>
      <div class="col-sm-6 counters">
        <div class="abouts center-text">
          <div>
            <div class="list-about">
              <p class="mb-2 mt-3">
                <ngx-skeleton-loader count="4" [theme]="{width:'20.6875em'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      }@case ('small') {
      <!-- Conteúdo para telas pequenas -->
      <div class="col-sm-4 counters set-height d-flex justify-content-center ms-5">
        <ngx-skeleton-loader [theme]="{height:'26.125em', width:'18.8875em'}" />
      </div>
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="7" [theme]="{width:'20.6875em', marginLeft:'5rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      }@case ('medium') {
      <!-- Conteúdo para telas Medias -->
      <div class="col-sm-4 counters set-height d-flex justify-content-center ms-5">
        <ngx-skeleton-loader [theme]="{height:'36.125em', width:'25.8875em', marginLeft:'7rem'}" />
      </div>
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'23.6875em', marginLeft:'10rem'}" />
              </p>
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'23.6875em', marginLeft:'10rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      }@case ('large') {
      <!-- Conteúdo para telas grandes -->
      <div class="col-sm-4 counters set-height d-flex justify-content-center ms-5">
        <ngx-skeleton-loader [theme]="{height:'38.125em', width:'30.8875em', marginLeft:'8rem'}" />
      </div>
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em', marginLeft:'12rem'}" />
              </p>
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em', marginLeft:'12rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      }@default {
      <!-- Conteúdo para demais telas -->
      <div class="col-sm-4 counters set-height d-flex justify-content-center ms-5">
        <ngx-skeleton-loader [theme]="{height:'38.125em', width:'30.8875em', marginLeft:'8rem'}" />
      </div>
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em', marginLeft:'12rem'}" />
              </p>
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em', marginLeft:'12rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      }
      }
      }

    </div>
  </div>
</section>


<!-- <div class="col-sm-4 counters set-height d-flex justify-content-center me-5">
  <picture>
    <ngx-skeleton-loader class="img-fluid mobile1 d-block" count="1" [appearance]="'line'"
      [theme]="{height:'675px'}" animation="pulse"></ngx-skeleton-loader>
  </picture>
</div>
<div class="col-sm-6 counters">
  <div class="abouts center-text">
    <div>
      <div class="format-small-text small-text-about">
        <p class="font-secondary borders-before text-uppercase"><span>{{smallText}}</span>
        </p>
      </div>
      <div class="format-head-text">
        <ngx-skeleton-loader animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="format-sub-text">
        <p class="about-para mb-2">{{subText}}</p>
      </div>
      <div class="list-about">
        <p class="mb-2">
          <ngx-skeleton-loader class="" count="3" animation="pulse" [theme]="{display:'flex', width:'500px'} "
            animation="pulse"></ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" [theme]="{width:'375px'}" animation="pulse"></ngx-skeleton-loader>
          <ngx-skeleton-loader count="3" [theme]="{display:'flex' , width:'500px'}"
            animation="pulse"></ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" [theme]="{width:'375px'}" animation="pulse"></ngx-skeleton-loader>
        </p>
      </div>
      <a></a>
    </div>
  </div>
</div> -->